<template>
  <div class="global-file-visor-container">
    <template v-if="base64 || srcNombre">
      <template v-if="mime === 'application/pdf'">
        <!-- obtiene el pdf del base64 convertido en blob -->
        <iframe v-if="base64" ref="pdf" :src="computedFile" type="application/pdf" scrolling="yes" style="overflow:hidden; height: 700px; width: 100%;" />
        <!-- obtiene el pdf del directorio assets/files del proyecto -->
        <iframe v-if="srcNombre" :src="srcNombre" scrolling="yes" style="overflow:hidden; height: 700px; width: 100%;" />
      </template>
      <template v-if="mime === 'image/jpeg' || mime === 'image/png'">
        <!-- obtiene el jpeg/png del base64 convertido en blob -->
        <img v-if="base64" :src="computedFile" :alt="nombreArchivo" class="global-file-visor-image" />
        <!-- obtiene el jpeg/png del directorio assets/files del proyecto -->
        <img v-if="srcNombre" :src="srcNombre" :alt="nombreArchivo" class="global-file-visor-image" />
      </template>
    </template>
    <template v-else>
      <h3>No se puede renderizar el archivo</h3>
    </template>
  </div>
</template>

<script>
/**
 * Componente que utiliza iframes e imgs para visualizar: PDFs e imagenes
 * TODO: añadir soporte para otros tipos de archivos, p ej docx, xlsx, etc
 */
export default {
  name: 'GlobalFileVisor',
  props: {
    /**
     * base64 del archivo pdf o imagen a ser renderizado
     */
    base64: {
      type: String,
      required: false,
      default: null
    },
    /**
     * nombre del archivo en assets/files
     * Tomar en cuenta que se debe configurar webpack en nuxt.config.js para
     * habilitar archivos.
     */
    srcNombre: {
      type: String,
      required: false,
      default: null
    },
    /**
     * mime del archivo
     * application/pdf
     * image/jpeg
     * image/png
     */
    mime: {
      type: String,
      required: false,
      default: null
    },
    /**
     * nombre del archivo
     */
    nombreArchivo: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    computedFile () {
      if (this.base64) {
        let blob = this.b64toBlob(this.base64, this.mime);
        let file = window.URL.createObjectURL(blob);
        return file;
      } else {
        return null;
      }
    },
    extension () {
      switch (this.mime) {
        case 'application/pdf':
          return 'pdf';
        case 'image/jpeg':
          return 'jpeg';
        case 'image/png':
          return 'png';
      }
      return '';
    }
  },
  methods: {
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }
  }
};
</script>
<style lang="scss">
.global-file-visor-container {
  overflow: hidden;
  text-align: center;
  width: auto;
}
.global-file-visor-image {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/common/util/GlobalFileVisor.vue